/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { TransPb } from "../../gen/body/trans";
import { PoseIdPb } from "../nav_cam_reconstruction/pose_id";
import {
  ObstacleAvoidanceEnum_Enum,
  obstacleAvoidanceEnum_EnumFromJSON,
  obstacleAvoidanceEnum_EnumToJSON,
} from "./obstacle_avoidance";
import { Waypoint } from "./waypoints";

export const protobufPackage = "skills";

export enum WaypointPanoramaMode {
  /**
   * PANO_UNSPECIFIED - NOTE(jose): This is a duplicate of the PanoramaMode enum in mission.proto. It cannot be
   * imported because of a circular dependency.
   */
  PANO_UNSPECIFIED = 0,
  HORIZONTAL = 1,
  VERTICAL = 2,
  SPHERE = 3,
  UNRECOGNIZED = -1,
}

export function waypointPanoramaModeFromJSON(object: any): WaypointPanoramaMode {
  switch (object) {
    case 0:
    case "PANO_UNSPECIFIED":
      return WaypointPanoramaMode.PANO_UNSPECIFIED;
    case 1:
    case "HORIZONTAL":
      return WaypointPanoramaMode.HORIZONTAL;
    case 2:
    case "VERTICAL":
      return WaypointPanoramaMode.VERTICAL;
    case 3:
    case "SPHERE":
      return WaypointPanoramaMode.SPHERE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WaypointPanoramaMode.UNRECOGNIZED;
  }
}

export function waypointPanoramaModeToJSON(object: WaypointPanoramaMode): string {
  switch (object) {
    case WaypointPanoramaMode.PANO_UNSPECIFIED:
      return "PANO_UNSPECIFIED";
    case WaypointPanoramaMode.HORIZONTAL:
      return "HORIZONTAL";
    case WaypointPanoramaMode.VERTICAL:
      return "VERTICAL";
    case WaypointPanoramaMode.SPHERE:
      return "SPHERE";
    case WaypointPanoramaMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface NcpgInfo {
  /**
   * NOTE(jose): We could move NcpgInfo to mission.proto and import_ it here to prevent the
   * current circular dependency
   */
  poseId:
    | PoseIdPb
    | undefined;
  /**
   * NOTE(duncan): this refers to nav_t_pose_id, which is the transform between the NAV frame and
   * the pose specified by `pose_id`
   * TOOD(duncan): Rename to default_nav_T_pose_id (renaming will be nontrivial considering the
   * translation that would need to happen for legacy JSON mission definitions)
   */
  defaultNavTrans:
    | TransPb
    | undefined;
  /**
   * NOTE(duncan): nav_takeoff_T_pose_id is the transform between the takeoff frame (NAV_TAKEOFF)
   * and the pose specified by `pose_id`
   */
  defaultNavTakeoffTPoseId: TransPb | undefined;
}

export interface ImageWaypoint {
  name: string;
  waypoint: Waypoint | undefined;
  timedWaitSeconds: number;
  subjectPhoto: boolean;
  navPanorama: boolean;
  subjectPanorama: boolean;
  ncpgInfo: NcpgInfo | undefined;
  transitOaSetting: ObstacleAvoidanceEnum_Enum;
  recordVideo: boolean;
  /** largest protobuf key: 11 */
  panoramaMode: WaypointPanoramaMode;
}

function createBaseNcpgInfo(): NcpgInfo {
  return { poseId: undefined, defaultNavTrans: undefined, defaultNavTakeoffTPoseId: undefined };
}

export const NcpgInfo = {
  encode(message: NcpgInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.poseId !== undefined) {
      PoseIdPb.encode(message.poseId, writer.uint32(10).fork()).ldelim();
    }
    if (message.defaultNavTrans !== undefined) {
      TransPb.encode(message.defaultNavTrans, writer.uint32(18).fork()).ldelim();
    }
    if (message.defaultNavTakeoffTPoseId !== undefined) {
      TransPb.encode(message.defaultNavTakeoffTPoseId, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NcpgInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNcpgInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.poseId = PoseIdPb.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.defaultNavTrans = TransPb.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.defaultNavTakeoffTPoseId = TransPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NcpgInfo {
    return {
      poseId: isSet(object.poseId) ? PoseIdPb.fromJSON(object.poseId) : undefined,
      defaultNavTrans: isSet(object.defaultNavTrans) ? TransPb.fromJSON(object.defaultNavTrans) : undefined,
      defaultNavTakeoffTPoseId: isSet(object.defaultNavTakeoffTPoseId)
        ? TransPb.fromJSON(object.defaultNavTakeoffTPoseId)
        : undefined,
    };
  },

  toJSON(message: NcpgInfo): unknown {
    const obj: any = {};
    if (message.poseId !== undefined) {
      obj.poseId = PoseIdPb.toJSON(message.poseId);
    }
    if (message.defaultNavTrans !== undefined) {
      obj.defaultNavTrans = TransPb.toJSON(message.defaultNavTrans);
    }
    if (message.defaultNavTakeoffTPoseId !== undefined) {
      obj.defaultNavTakeoffTPoseId = TransPb.toJSON(message.defaultNavTakeoffTPoseId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NcpgInfo>, I>>(base?: I): NcpgInfo {
    return NcpgInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NcpgInfo>, I>>(object: I): NcpgInfo {
    const message = createBaseNcpgInfo();
    message.poseId = (object.poseId !== undefined && object.poseId !== null)
      ? PoseIdPb.fromPartial(object.poseId)
      : undefined;
    message.defaultNavTrans = (object.defaultNavTrans !== undefined && object.defaultNavTrans !== null)
      ? TransPb.fromPartial(object.defaultNavTrans)
      : undefined;
    message.defaultNavTakeoffTPoseId =
      (object.defaultNavTakeoffTPoseId !== undefined && object.defaultNavTakeoffTPoseId !== null)
        ? TransPb.fromPartial(object.defaultNavTakeoffTPoseId)
        : undefined;
    return message;
  },
};

function createBaseImageWaypoint(): ImageWaypoint {
  return {
    name: "",
    waypoint: undefined,
    timedWaitSeconds: 0,
    subjectPhoto: false,
    navPanorama: false,
    subjectPanorama: false,
    ncpgInfo: undefined,
    transitOaSetting: 0,
    recordVideo: false,
    panoramaMode: 0,
  };
}

export const ImageWaypoint = {
  encode(message: ImageWaypoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(58).string(message.name);
    }
    if (message.waypoint !== undefined) {
      Waypoint.encode(message.waypoint, writer.uint32(10).fork()).ldelim();
    }
    if (message.timedWaitSeconds !== 0) {
      writer.uint32(29).float(message.timedWaitSeconds);
    }
    if (message.subjectPhoto === true) {
      writer.uint32(48).bool(message.subjectPhoto);
    }
    if (message.navPanorama === true) {
      writer.uint32(32).bool(message.navPanorama);
    }
    if (message.subjectPanorama === true) {
      writer.uint32(40).bool(message.subjectPanorama);
    }
    if (message.ncpgInfo !== undefined) {
      NcpgInfo.encode(message.ncpgInfo, writer.uint32(66).fork()).ldelim();
    }
    if (message.transitOaSetting !== 0) {
      writer.uint32(72).int32(message.transitOaSetting);
    }
    if (message.recordVideo === true) {
      writer.uint32(80).bool(message.recordVideo);
    }
    if (message.panoramaMode !== 0) {
      writer.uint32(88).int32(message.panoramaMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ImageWaypoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImageWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 7:
          if (tag !== 58) {
            break;
          }

          message.name = reader.string();
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.waypoint = Waypoint.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.timedWaitSeconds = reader.float();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.subjectPhoto = reader.bool();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.navPanorama = reader.bool();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.subjectPanorama = reader.bool();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.ncpgInfo = NcpgInfo.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.transitOaSetting = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.recordVideo = reader.bool();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.panoramaMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImageWaypoint {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      waypoint: isSet(object.waypoint) ? Waypoint.fromJSON(object.waypoint) : undefined,
      timedWaitSeconds: isSet(object.timedWaitSeconds) ? globalThis.Number(object.timedWaitSeconds) : 0,
      subjectPhoto: isSet(object.subjectPhoto) ? globalThis.Boolean(object.subjectPhoto) : false,
      navPanorama: isSet(object.navPanorama) ? globalThis.Boolean(object.navPanorama) : false,
      subjectPanorama: isSet(object.subjectPanorama) ? globalThis.Boolean(object.subjectPanorama) : false,
      ncpgInfo: isSet(object.ncpgInfo) ? NcpgInfo.fromJSON(object.ncpgInfo) : undefined,
      transitOaSetting: isSet(object.transitOaSetting)
        ? obstacleAvoidanceEnum_EnumFromJSON(object.transitOaSetting)
        : 0,
      recordVideo: isSet(object.recordVideo) ? globalThis.Boolean(object.recordVideo) : false,
      panoramaMode: isSet(object.panoramaMode) ? waypointPanoramaModeFromJSON(object.panoramaMode) : 0,
    };
  },

  toJSON(message: ImageWaypoint): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.waypoint !== undefined) {
      obj.waypoint = Waypoint.toJSON(message.waypoint);
    }
    if (message.timedWaitSeconds !== 0) {
      obj.timedWaitSeconds = message.timedWaitSeconds;
    }
    if (message.subjectPhoto === true) {
      obj.subjectPhoto = message.subjectPhoto;
    }
    if (message.navPanorama === true) {
      obj.navPanorama = message.navPanorama;
    }
    if (message.subjectPanorama === true) {
      obj.subjectPanorama = message.subjectPanorama;
    }
    if (message.ncpgInfo !== undefined) {
      obj.ncpgInfo = NcpgInfo.toJSON(message.ncpgInfo);
    }
    if (message.transitOaSetting !== 0) {
      obj.transitOaSetting = obstacleAvoidanceEnum_EnumToJSON(message.transitOaSetting);
    }
    if (message.recordVideo === true) {
      obj.recordVideo = message.recordVideo;
    }
    if (message.panoramaMode !== 0) {
      obj.panoramaMode = waypointPanoramaModeToJSON(message.panoramaMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImageWaypoint>, I>>(base?: I): ImageWaypoint {
    return ImageWaypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImageWaypoint>, I>>(object: I): ImageWaypoint {
    const message = createBaseImageWaypoint();
    message.name = object.name ?? "";
    message.waypoint = (object.waypoint !== undefined && object.waypoint !== null)
      ? Waypoint.fromPartial(object.waypoint)
      : undefined;
    message.timedWaitSeconds = object.timedWaitSeconds ?? 0;
    message.subjectPhoto = object.subjectPhoto ?? false;
    message.navPanorama = object.navPanorama ?? false;
    message.subjectPanorama = object.subjectPanorama ?? false;
    message.ncpgInfo = (object.ncpgInfo !== undefined && object.ncpgInfo !== null)
      ? NcpgInfo.fromPartial(object.ncpgInfo)
      : undefined;
    message.transitOaSetting = object.transitOaSetting ?? 0;
    message.recordVideo = object.recordVideo ?? false;
    message.panoramaMode = object.panoramaMode ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
